export default function AaaRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100%;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto;
                        width: 100%; 
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">

                            <div>
                                <div>
                                    <center>
                                        <h1><b>Amar Akbar Anthony</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To predict whether the drawn card will land on Amar, Akbar, or Anthony.</p>
                                        </div>
                                        <div>
                                            <h3><b>Game Rules</b></h3>
                                            <p class="pt20">Hands dealt: 1 (Amar/Akbar/Anthony).</p>
                                            <strong>Bets</strong>
                                            <p><strong>Amar wins:</strong> If dealt card is either A,2,3,4,5,6 of any suit</p>
                                            <p><strong>Akbar wins:</strong> If dealt card is either 7,8,9,10 of any suit</p>
                                            <p><strong>Anthony wins:</strong> If dealt card is either J,Q,K of any suit</p>
                                            <p class="pt20">Number Ranking: Lowerst to highest: Ace, 2, 3, 4, 5, 6, 7,8, 9, 10, Jack, Queen, and King (Ace is "1" and King is "13").</p>
                                        </div>
                                        <div>
                                            <h3><b>Materials</b></h3>
                                            <p class="pt20">A standard deck of 52 playing cards. </p>
                                        </div>

                                        <div>
                                            <h3><b>PAYOUT</b></h3>
                                            <table class="table">
                                                <tbody><tr><td>Amar</td><td>1:1.12</td></tr>
                                                    <tr><td>Akbar</td><td>1:2.15</td></tr>
                                                    <tr><td>Anthony</td><td>1:3.15</td></tr>
                                                </tbody></table>
                                        </div>
                                    </center>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}